export default __webpack_public_path__ + "static/media/banner.16c7fd91.jpeg";